import * as React from 'react';
import { FaArrowUp } from 'react-icons/fa';
import { NftCard } from './NftCard';

export function Inv(props) {
  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      <div>
        <br></br>
      </div>
      <button className='btn btn-sm' onClick={props.scrollOwnedNfts}>
        <span style={{ color: '#0178db' }}>
          View your collection of owned SKYFACEs at the bottom of the page
        </span>
      </button>
      <div style={{ paddingTop: '15px' }}>
        <span style={{ color: '#0178db' }}>
          (each with their full high-resolution rendering to view or save,{' '}
          <br></br>and each their links to share on Twitter and Instagram.)
        </span>
      </div>
      <div>
        <br></br>
      </div>
      <div className='grid grid-cols-3 md:grid-cols-3 xl:grid-cols-3 gap-4'>
        {props.ids &&
          props.ids.map((id) => (
            <NftCard
              key={id}
              id={id}
              addToCart={props.addToCart}
              removeFromCart={props.removeFromCart}
              bigPrice={props.bigPrice}
              eth={props.eth}
              inCartStatus={props.inCartStatus}
              resetCart={props.resetCart}
              sold={props.sold}
              setSold={props.setSold}
            />
          ))}
      </div>
      <br></br>
      <div
        style={{
          backgroundColor: '#000000',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          paddingTop: '100px',
          paddingBottom: '100px',
        }}
      >
        <iframe
          src='https://dashboard.mailerlite.com/forms/404961/85932441383994876/share'
          style={{
            width: '600px',
            height: '260px',
            backgroundColor: '#000000',
          }}
          frameborder='0'
          scrolling='no'
          title='mailing list'
        ></iframe>
      </div>
      <button
        className='fixed bottom-4 right-4 bg-primary-500 text-white rounded-full p-2 shadow-lg'
        onClick={handleScrollToTop}
      >
        <FaArrowUp />
      </button>
    </>
  );
}
